import { Variables } from './../../../styles/variables'
import styled from "styled-components";

export const Container = styled.div`
    height: 56px;
    box-shadow: 0 8px 24px rgba(81, 98, 116, 0.12);
    background: #F4C600;
    border-radius: 0px 0px 16px 16px;
    position: fixed;
    z-index: 1111;
    width: 100%;

    .navbar {
        .logo {
            cursor: pointer;
        }
        
        .dropdown-img {
            button {
                background: transparent;
                border: unset;

                img {
                    height: 40px;
                    border-radius: 100%;
                }
            }

            .dropdown-menu {
                right: 0px;
                
                li {
                    padding: 8px;
                    gap: 8px;
                    align-items: center;
                    color: #516274;

                    img, svg {
                        width: 18px;
                        height: 18px;
                        flex-shrink: 0;
                    }
                
                    &:hover {
                        background: ${Variables.yellow};
                    }

                    .dropdown-item {
                        padding: 0px;
                        
                        &:hover {
                            background: unset;
                        }
                    }
                }
            }
        }

        .collapse {
            .login-text {
                cursor: pointer;
                margin-right: 16px;
                font-size: 14px;
                line-height: 20px;
                font-weight: 600;
                margin-right: 20px;
                color: #516274;
            }

            .leave-text {
                cursor: pointer;
                margin-left: 16px;
                margin-right: 16px;
                font-size: 14px;
                line-height: 20px;
                font-weight: 600;
                height: 42px;
                color: #516274;

                .icon {
                    margin-right: 9.5px;
                }
            }

            .btn-register {
                margin-right: 24px;
            }
        }
    }

    @media (max-width: 575.98px) {
        .navbar {
            .navbar-collapse {
                margin-top: 12px;
            }
        }
    }

    @media (max-width: 767.98px) {}

    @media (max-width: 991.98px) {
        height: auto;
    }

    @media (max-width: 1199.98px) {}

    @media (max-width: 1399.98px) {}
`